import React, { useEffect, useState } from "react";
import "./style3.css";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import Spinner from "../../components/LoadingSpinner/loadingSpinner";
import Cookies from "js-cookie";
import api from "../../api";

const baseUrl = process.env.REACT_APP_BASE_URL;

const SpecialofferModal = ({ show, onClose, offer, onReject, offerId }) => {
  const [languageData, setLanguageData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/offerModal/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  const discountItem = offer?.items?.find((item) => item.discounts);
  const packages = discountItem?.packages || [];
  const packageNames = packages.map((pkg) => pkg.name).join(", ");
  const currencyMap = {
    EUR: "€",
    USD: "$",
    GBP: "£",
  };

  const currencySymbol = currencyMap[offer?.currency] || offer?.currency || "";
  const handleCancelOffer = () => {
    if (offer?.id) {
      Cookies.set(`disableSpecialOfferAutoOpen_${offer.id}`, "1");
    }

    onClose();
  };
  const handleTakeOffer = async () => {
    try {
      setLoading(true);
      const res = await api.post(`/invoicing/orders/create`, {
        source_id: offerId,
        source_type: "loyalty_program",
      });
       const payment_link = res?.data?.data?.payment_link;
      Swal.fire({
        icon: "success",
        title: languageData.alert.success.title,
        confirmButtonText: languageData.alert.success.button,
      }).then((result) => {
        if (!result.isConfirmed) return;

        const width = 800;
        const height = 900;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
       onClose();
       window.open(
          payment_link,
          "PaymentWindow",
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
        );
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: languageData.alert.error.title,
        text: languageData.alert.error.description,
      });
    } finally {
      setLoading(false);
    }
  };
  if (!languageData) {
    return <div></div>;
  }

  const imageByType = {
    free_product: "./assets/images/free_product.png",
    package: "./assets/images/package.png",
  };
  return (
    <div>
      <Modal
        show={show}
        onHide={onClose}
        centered
        dialogClassName="SpecialOfferModal custom-modal-dialog"
      >
        <div class="modalSpecialOffer">
          <div class="flex">
            <div class="flex flex-column justify-content-center align-items-center w-50">
              <h1 class="OfferName text-center"> {offer?.name}</h1>
              <span class="OfferDescription text-center">
                {offer?.description}
              </span>
              <div class="flex gap-8p align-items-center">
                <h2 class="priceReduction">
                  {" "}
                  {currencySymbol}
                  {parseFloat(offer?.discounted_price || 0)}
                </h2>
                <h2 class="OfferPrice">
                  {currencySymbol}
                  {parseFloat(offer?.price || 0)}
                </h2>
              </div>
  {offer.items?.map((item) => (
  item.type === "discount" && (
    <p className="reduction" key={item.id}>
      <span className="reducePercent font-700">
        {parseFloat(item.discounts?.value)}%
      </span>
    </p>
  )
))}

              <span class="u-text-4 Name_service font-600">{packageNames}</span>
              <h4 class=" font-300 font-14 u-text-4">
                {languageData.limit}
                <span class="start_time ">{offer?.date_end}</span>
              </h4>
              <button  data-interaction="take_offer_modal_button"
                class="btn bg-accent1 text-white pulse introductoryOffer"
                onClick={handleTakeOffer}
              >
                {" "}
                {languageData.actions.button}
              </button>
              <button  data-interaction="cancel_modal_offer"
                type="button"
                class="btn-no close-offer-btn mt-15"
                onClick={onReject}
              >
                {" "}
                {languageData.actions.cancel}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default SpecialofferModal;
